import { render, staticRenderFns } from "./ClasificacionArtistasPorIncrementoPorcentualPopularidad.vue?vue&type=template&id=0992fe7b&"
import script from "./ClasificacionArtistasPorIncrementoPorcentualPopularidad.vue?vue&type=script&lang=js&"
export * from "./ClasificacionArtistasPorIncrementoPorcentualPopularidad.vue?vue&type=script&lang=js&"
import style0 from "./ClasificacionArtistasPorIncrementoPorcentualPopularidad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports